import { CalendarDays } from 'lucide-react';
import { formatDateRangeWithYear } from '@/utils/date';
import { PillBadge } from './PillBadge';

const DATE_RANGE_BUTTON_CLASS =
  'inline-flex shrink-0 cursor-pointer rounded-full outline-none transition-shadow hover:ring-2 hover:ring-brand-link/25 focus-visible:ring-2 focus-visible:ring-brand-link/50';

export interface DateRange {
  dateFrom: string | undefined;
  dateTo: string | undefined;
}

interface DateRangeBadgeProps extends DateRange {
  onClick?: (() => void) | undefined;
}

export function DateRangeBadge({ dateFrom = '', dateTo = '', onClick }: DateRangeBadgeProps) {
  if (!dateFrom && !dateTo) return null;

  const rangeText = formatDateRangeWithYear(dateFrom, dateTo);
  const badge = (
    <PillBadge icon={CalendarDays} screenReaderLabel="Date range:">
      {rangeText}
    </PillBadge>
  );
  if (!onClick) return badge;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Date range ${rangeText}. Open Filters to change it.`}
      className={DATE_RANGE_BUTTON_CLASS}
    >
      {badge}
    </button>
  );
}
